module.exports = __webpack_public_path__ + "img/5362f33b4d169.SLDASM.7043ff26.jpg";